<template>
    <div
        v-if="airlineKnown"
        class="flightlogo"
        :style="{ backgroundImage: airlineLogo }"
    ></div>
    <b v-else="">
        {{ flightNumber }}
    </b>
</template>

<script>
export default {
    name: 'FlightLogo',

    data: function() {
        return {
            availableCarriers: [
                'KL',
                'FR',
                'AF',
                'U2',
                'VY',
                'LH',
                'BA',
                'HV',
                'TO',
                'IB',
                'AB',
                'SN',
                'E2',
                'EW',
                'LX',
                'UA',
                'AA',
                'DA',
                'SQ',
                'CX',
                'BE',
                'EK',
                'TK',
                'PC',
                'GF',
                'RJ',
                'QF',
                'TP',
                'DL',
                'UX',
                'VK',
            ],
        }
    },
    props: {
        flightNumber: String,
    },
    computed: {
        airlineKnown: function() {
            return this.availableCarriers.includes(
                this.flightNumber.substring(0, 2)
            )
        },
        airlineLogo: function() {
            let airlineLogoSub = this.flightNumber.substring(0, 2)
            return (
                'url(https://cdn.cruisereizen.nl/img/flightcarriers/' +
                airlineLogoSub +
                '.png)'
            )
        },
    },
}
</script>

<style scoped>
.flightlogo {
    display: block;
    width: 60px;
    height: 18px;
    background-position: center;
    background-repeat: no-repeat;
}
</style>
